import React from 'react';
import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import Loading from '../../loading';
import $ from "jquery";
import Server from '../../../functions/server';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';

const styles = { appBar: { position: 'relative', }, flex: { flex: 1, }, };

function Transition(props) { return <Slide direction="up" {...props} />; }

class CancelledInvoice extends React.Component {

  state = {
    cancelledInvoice: [],
  }

  viewCancelledInvoice() {
    let context = this;
    context.setState({ load: true, message: 'Getting Cancelled Invoice!!!' });
    $.ajax({
      type: 'POST', data: { 'branch': this.props.selectedBranch },
      url: Server() + 'quotation/getcancelledorder.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ viewCancelledInvoice: true, cancelledInvoice: data, load: false })
        } catch (e) {
          alert('error'); context.setState({ load: false })
        }
      },
      error: function(err) {
        alert('Try Again!!!')
        context.setState({ load: false })
      }
    })
  }


  getPdf(id) {
    let open = Server() + 'pdf/canceledinvoice/canceledinvoice.php?orderid='+id;
    window.open(open);
  }

  render() {
    const { classes } = this.props;
    let i = 1;
    return (
      <div>
        <Button onClick={this.viewCancelledInvoice.bind(this)}>Cancelled Invoice</Button>
        <Loading load={this.state.load} message={this.state.message} />
        <Dialog fullScreen open={this.state.viewCancelledInvoice}
          onClose={ () => { this.setState({ viewCancelledInvoice: false }) }} TransitionComponent={Transition}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton color="inherit" onClick={ () => { this.setState({ viewCancelledInvoice: false }) }} aria-label="Close"> <CloseIcon />
              </IconButton>
              <Typography variant="h6" color="inherit" className={classes.flex}> Cancelled Invoice </Typography>
            </Toolbar>
          </AppBar>
          <table id='table' width="100%">
            <tr>
              <th>Sino</th>
              <th>Voucher Number</th>
              <th>Cancelled By</th>
              <th>Total</th>
              <th>Reason</th>
              <th>PDF</th>
            </tr>
            { this.state.cancelledInvoice.map((c) => {
                let total = c.total;
                try {
                  total = Number(total).toFixed(2);
                } catch (e) {
                }
                return (
                  <tr>
                    <td>{i++}</td>
                    <td>{c.invoice_voucher}</td>
                    <td>{c.executivename}</td>
                    <td>{total}</td>
                    <td>{c.cancel_reason}</td>
                    <th style={{cursor: 'pointer'}} onClick={this.getPdf.bind(this, c.order_id)}>View</th>
                  </tr>
                )
              })
            }
          </table>
         </Dialog>
      </div>
    );
  }
}

CancelledInvoice.propTypes = { classes: PropTypes.object.isRequired, };

export default withStyles(styles)(CancelledInvoice);
